import AppConstants from '../gorillaboy/AppConstants';
import * as moment from 'moment';
import * as _ from 'lodash-es';

//Deliberately not indenting/formatting the below code to avoid merge conflicts. This file is converted into TypeScript in this commit.

    function CheckinCheckoutController($rootScope, $log, $translate, $location, 
                                       DocumentService, MessageManager, 
                                       ModalFactory, ResourceService, $q, $uibModal) {
        var $scope = null,
            lockedIconClsForSomebodyElse = 'locked-808184',
            lockedIconClsForLoggedInUser = 'locked-0e72a3',
            userInfo = null;
        return {
            initScope : initScopeFn
        };

        function initScopeFn(scopeVal, userInfoVal) {

            $scope = scopeVal;
            userInfo = userInfoVal;
            $scope.$on('$destroy', function() {
                $scope = null;
                userInfo = null;
            });

            $scope.getO365DisabledTooltip = function(doc) {
                if ($scope.isO365FeatureEnabled()) {
                    if (!$rootScope.office365EditingEnabled) {
                        return $translate.instant('TOP_NAV.OPEN_WITH_OFFICE_DISABLED_TOOLTIP');
                    } else if ($scope.isOfficeLegacyFile(doc)) {
                        return $translate.instant('O365_OPTION_DISABLED_REASON');
                    } else if ($scope.isDocumentCheckedOut(doc) && !$scope.isDocumentCheckedOutByO365(doc)) {
                        return $translate.instant('O365.OPTION_DISABLED_DUE_TO_LOCK');
                    }                        
                }
                return '';
            };
            
            $scope.isO365EditingOptionDisabled = function(doc) {
                return !!$scope.getO365DisabledTooltip(doc);
            };
            
            $scope.isDocumentCheckedOutByHancom = function(doc) {
            	return (doc.CheckoutInfo && doc.CheckoutInfo.CheckoutUserId === AppConstants.APP_LOCK_IDS.HANCOM);
            };

            $scope.isDocumentCheckedOut = function(doc) {
                return !!(doc.CheckoutInfo);
            };

            $scope.isDocumentCheckedOutByLoggedInUserCommon = function(doc) {
                return (doc.CheckoutInfo && doc.CheckoutInfo.CheckoutUserId === userInfo.Id);
            };

            $scope.isDocumentCheckedOutByAnApp = function(doc) {
                return (doc.CheckoutInfo && doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP);
            };

            $scope.isDocumentCheckedOutByO365 = function(doc) {
                return (doc.CheckoutInfo && doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP 
                        && doc.CheckoutInfo.CheckoutUserId === AppConstants.APP_LOCK_IDS.O365);
            };

            $scope.isDocumentCheckedOutByOtherUser = function(doc) {
                return (doc.CheckoutInfo && doc.CheckoutInfo.CheckoutUserId !== userInfo.Id && !doc.CheckoutInfo.LockType);
            };

            var getRelativeTime = _.memoize(function(time) {
                return moment(time).fromNow()
            });

            $scope.getCheckedOutTooltip = function(document) {
                var CheckoutInfo = document.CheckoutInfo;
                if (document.wopiUnlockError) {
                    return $translate.instant('O365.WOPI_UNLOCK_TIMEDOUT');
                }
                if (document.wopiUnlockComplete) {
                    return $translate.instant('O365.WOPI_UNLOCK_COMPLETE');
                }
                if (CheckoutInfo) {
                    if (CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP) {
                        return $translate.instant('EXTERNAL_EDIT.LIVE_EDIT_IN_PROGRESS');
                    } else {
                        return $translate.instant(CheckoutInfo.CheckoutUserId === userInfo.Id ? 'CHECKIN_CHECKOUT.TOOLTIPS.SELF_CHECKEDOUT' : 'CHECKIN_CHECKOUT.TOOLTIPS.OTHER_USER_CHECKEDOUT', {
                            Name : CheckoutInfo.CheckoutUserName,
                            RelativeDateTime : getRelativeTime(document.CheckoutInfo.CheckoutTime)
                        });
                    }
                }
            };
            
            $scope.getCheckedOutTooltipForDocumentViewer = function(CheckoutInfo) {
                if(!CheckoutInfo) {
                    return "";
                }
                if (CheckoutInfo && CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP) {
                    return $translate.instant('EXTERNAL_EDIT.LIVE_EDIT_IN_PROGRESS');
                }
                return $translate.instant((CheckoutInfo && CheckoutInfo.CheckoutUserId === userInfo.Id) ? 'CHECKIN_CHECKOUT.TOOLTIPS.SELF_CHECKEDOUT' : 'CHECKIN_CHECKOUT.TOOLTIPS.OTHER_USER_CHECKEDOUT_DOC_VIEWER', {
                    Name : CheckoutInfo.CheckoutUserName,
                    RelativeDateTime : getRelativeTime($scope.metadata.CheckoutInfo.CheckoutTime)
                });
            };

            /**
             * The following method calls the ResourceService and takes care of error handling
             */
            $scope.checkoutDocumentCommon = function(docId, message) {
                getRelativeTime.cache.clear();    //clear the getRelativeTime cache when a document is checked out
                return ResourceService.checkout(docId, message).then(function(success) {
                    MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.MESSAGES.CHECKOUT.SUCCESS'));
                    return success;
                }, function(response) {
                    MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.ERROR_WHILE_CHECKING_OUT'));
                    return $q.reject(response);
                });
            };

            $scope.unlockDocumentCommon = function(resourceId, resourceName) {
                return ResourceService.checkin(resourceId, '').then(function(response) {
                    MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.MESSAGES.CHECKIN.SUCCESS'));
                }, function(response) {
                    MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.CHECKIN_MODAL.ERROR_WHILE_CHECKING_IN'));
                    return $q.reject(response);
                });
            };

            $scope.discardCheckoutCommonCinCoutCtrl = function(resourceId) {
                return ResourceService.discardCheckout(resourceId, '').then(function(response) {
                    MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.MESSAGES.DISCARD_CHECKOUT.SUCCESS'));
                }, function(response) {
                    MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.DISCARD_CHECKOUT_ERROR'));
                    return $q.reject(response);
                });
            };

            $scope.requestCheckin = function(ResourceId, CheckouteeName, isProprietor) {
                var shareModal = $uibModal.open({
                    templateUrl: './shared/request_checkin_modal.html',
                    controller: 'RequestCheckinModalController',
                    size: 'lg',
                    resolve: {
                        ResourceId : function() {
                            return ResourceId;
                        },
                        isProprietor : function() {
                            return isProprietor;
                        },
                        CheckouteeName : function() {
                            return CheckouteeName;
                        }
                    }
                });
                return shareModal.result;
            };

            $scope.discardCheckoutForProprietor = function(ResourceId, ResourceName) {
                var shareModal = $uibModal.open({
                    templateUrl: './shared/proprietor_discard_checkout_modal.html',
                    controller: 'ProprietorDiscardCheckoutModalController',
                    size: 'lg',
                    resolve: {
                        ResourceId : function() {
                            return ResourceId;
                        },
                        ResourceName : function() {
                            return ResourceName;
                        }
                    }
                });

                return shareModal.result;
            };

            $scope.discardCheckoutForCheckoutee = function(docId) {
                return ResourceService.discardCheckout(docId).then(function(response) {
                    MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.MESSAGES.DISCARD_CHECKOUT.SUCCESS'));
                }, function(response) {
                    MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.DISCARD_CHECKOUT_ERROR'));
                    return $q.reject(response);
                });
            };            
        }
    }


    /**
     * @ngdoc service
     * @name CheckinCheckoutController
     *
     * @description
     * CheckinCheckoutController is a base class checkin/checkout functionality inherited by FileBrowserController and DocumentControllers
     */
    angular.module('GorillaBoy')
    .factory('CheckinCheckoutController', [
        '$rootScope',
        '$log',
        '$translate',
        '$location',
        'DocumentService',
        'MessageManager',
        'ModalFactory',
        'ResourceService',
        '$q',
        '$uibModal',
        CheckinCheckoutController
    ]);
